import { render, staticRenderFns } from "./LiveRankGame.vue?vue&type=template&id=461bef5a&scoped=true"
import script from "./LiveRankGame.vue?vue&type=script&lang=js"
export * from "./LiveRankGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461bef5a",
  null
  
)

export default component.exports